import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { useHistory, useLocation } from 'react-router';
import './shortcut-bar.scss';

export interface Shortcut {
  id: string;
  label: string;
  locked?: boolean;
}

interface ShortcutBarProps {
  shortcuts: Shortcut[];
  activeId: string | null;
  onSelect: (shortcut: Shortcut) => void;
  searchBubble?: React.ReactNode;
  onSearchBubbleRemove?: () => void;
  // Optional element rendered at the start of the row (left of the first pill),
  // e.g. the "Selected (#)" filter pill shown when EGMs are selected.
  leading?: React.ReactNode;
  // Optional element rendered at the end of the row (right of the last pill),
  // e.g. the Compare action shown when 2+ EGMs are selected.
  trailing?: React.ReactNode;
}

const ShortcutBar: React.FC<ShortcutBarProps> = ({
  shortcuts,
  activeId,
  onSelect,
  searchBubble,
  onSearchBubbleRemove,
  leading,
  trailing,
}) => {
  const hasSearch = !!searchBubble;
  const history = useHistory();
  const location = useLocation();

  return (
    <div className="shortcut-bar">
      {leading}
      {hasSearch && searchBubble}
      {!hasSearch &&
        shortcuts.map((shortcut) => (
          <button
            key={shortcut.id}
            className={`shortcut-pill${activeId === shortcut.id ? ' shortcut-pill--active' : ''}${shortcut.locked ? ' shortcut-pill--locked' : ''}`}
            onClick={() => {
              if (shortcut.locked) {
                history.push('/auth/stripe', { previousPage: location.pathname });
                return;
              }
              onSelect(shortcut);
            }}
          >
            {shortcut.label}
            {shortcut.locked && (
              <FontAwesomeIcon icon={faLock} className="shortcut-pill__lock-icon" />
            )}
          </button>
        ))}
      {trailing}
    </div>
  );
};

export default ShortcutBar;
